<template>
  <div
    id="404"
    class="page"
  >
    <section
      id="content_section"
      class="container bg-white text-left py-4"
    >
      <div class="content py-4">
        <h1 class="articleTitle text-osc">
          {{ $t('page.not_found') }}
        </h1>
        <div class="articleBodyFullWidth">
          <h5 class="font-weight-normal">
            {{ $t('others.hint_not_found') }}
          </h5>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  name: "NotFound",
  mounted() {
    this.$router.replace("/404");
  }
};
</script>
